import _ from 'lodash';

import { RESET_STATE } from 'store/global/actions';

import {
  CREATE_DOCUMENT_FIELD_TYPES,
  DELETE_DOCUMENT_FIELD_TYPES,
  EDIT_DOCUMENT_FIELD_TYPES,
  GET_DOCUMENT_FIELD_TYPES,
  RESET_DOCUMENT_FIELD_TYPES,
} from '../actions';

const initialState = {};

const documentFieldTypesReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_DOCUMENT_FIELD_TYPES:
      return payload.documentFieldTypes || initialState;

    case EDIT_DOCUMENT_FIELD_TYPES:
      return { ...state, [payload.id]: payload };

    case CREATE_DOCUMENT_FIELD_TYPES:
      return { [payload.id]: payload, ...state };

    case DELETE_DOCUMENT_FIELD_TYPES:
      return _.omit(state, payload);

    case RESET_DOCUMENT_FIELD_TYPES:
    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default documentFieldTypesReducer;
